var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhotoCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 11.9999H41.562L39.94 5.51394C39.7172 4.62414 38.9174 4 38 4H18C17.0826 4 16.283 4.62414 16.0599 5.51394L14.438 11.9999H6C2.68629 11.9999 0 14.6862 0 17.9999V45.9999C0 49.3136 2.68629 51.9999 6 51.9999H50C53.3137 51.9999 56 49.3136 56 45.9999V17.9999C56 14.6862 53.3137 11.9999 50 11.9999ZM27.9999 41.9999C22.4771 41.9999 18 37.5228 18 31.9999C18 26.4771 22.4771 22 27.9999 22C33.5228 22 37.9999 26.4771 37.9999 31.9999C37.9933 37.5201 33.5201 41.9933 27.9999 41.9999Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhotoCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/photo-camera.4680b3c5.svg";
export { ForwardRef as ReactComponent };